/**
 * Alerts trends API service.
 *
 * Provides dashboard endpoints for trends charts, KPI cards,
 * and overall alerts count views.
 */

import api from "@/services/apiClient";
import type {
  AlertsTrendsIntr,
  AlertsTrendItem,
} from "../types/alertsTrends.types";
import type { WrapAlertsCounts } from "@/features/alerts/types/alerts.types";

export const alertsTrendService = {
  /**
   * Requests alerts trend KPI and chart data for the dashboard.
   * @param payload Alerts trends request payload.
   * @param config Optional request configuration.
   * @returns Alerts trends API response.
   */
  GetAlertsTrend: (
    payload: AlertsTrendsIntr,
    config?: { signal?: AbortSignal },
  ): Promise<AlertsTrendItem> =>
    api
      .post("AlertsTrend/GetAlertsTrends", payload, config)
      .then((res) => res.data),
  /**
   * Requests overall alerts count data grouped for tabular display.
   * @param payload Alerts trends request payload.
   * @returns Overall alerts count response.
   */
  GetOverallAlertsCount: (payload: AlertsTrendsIntr): Promise<WrapAlertsCounts> =>
    api.
      post("Customers/GetOverallAlertsCount", payload)
      .then((res) => res.data),
};
  